<template>
  <div class="page">
    <div class="navi">
      <a @click="back" class="back">{{ $t("index.back") }}</a>
    </div>
    <div class="header">
      <span class="title"></span><span class="tip">{{ $t("index.videoin") }}</span>
    </div>
    <div class="videoBox">
      <div class="left">
        <video
          class="video"
          id="videoBox"
          controls
          autoplay
          width="960"
          height="540"
          src=""
        ></video>
        <div class="info"></div>
      </div>

      <div class="directory">
        <div class="directory-header">{{ $t("index.videoList") }}</div>
        <div class="directory-content">
          <ul style="padding-left: 0px" class="ulbox" v-html="createDom(list)"></ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
const list = [
  {
    id: "0",
    name: "软件登录与使用流程",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/软件登录与使用流程(1).mp4",
    info: "主要介绍了软件如何登录以及使用的流程。",
  },
  {
    id: "1",
    name: "创建任务与导出",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/创建任务及导入 (2).mp4",
    info: "主要介绍了任务的创建与导出。",
  },
  {
    id: "2",
    name: "一键设置",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/一键设置 (3).mp4",
    info: "主要描述了一键设置。",
  },
  {
    id: "3",
    name: "自动排样",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/自动排样 (4).mp4",
    info: "主要介绍了如何进行自动排样。",
  },
  {
    id: "4",
    name: "手动排样",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/手动排样 (5).mp4",
    info: "主要描述了如何手动排样。",
  },
  {
    id: "5",
    name: "自动排序",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/自动排序 (6).mp4",
    info: "主要介绍了如何自动排序。",
  },
  {
    id: "6",
    name: "手工排序",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/手工排序 (7).mp4",
    info: "主要描述了如何手工排序。",
  },
  {
    id: "7",
    name: "排样-工艺-排序",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/排样-工艺-排序(8).mp4",
    info: "主要介绍了排样-工艺-排序的步骤。",
  },
  {
    id: "8",
    name: "编辑共边刀路",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/编辑共边刀路 (9).mp4",
    info: "主要描述了如何编辑共边刀路。",
  },
  {
    id: "9",
    name: "余料",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/余料(10).mp4",
    info: "主要描述了余料有关内容。",
  },
  {
    id: "10",
    name: "骨架切碎",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/骨架切碎(11).mp4",
    info: "主要介绍了如何进行骨架切碎操作。",
  },
  {
    id: "11",
    name: "报告单",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/报告单 (12).mp4",
    info: "主要描述了报告单。",
  },
  {
    id: "12",
    name: "导出NC",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/导出NC(13).mp4",
    info: "主要介绍了如何进行导出NC的操作。",
  },
  {
    id: "13",
    name: "自动微连",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/自动微连 (14).mp4",
    info: "主要描述了什么是自动微连。",
  },
  {
    id: "14",
    name: "外部批量导入",
    type: "video",
    url: "https://cloud.bodor.com/Portal/assets/videos/外部批量导入 (15).mp4",
    info: "主要介绍了如何进行外部批量导入操作。",
  },
];

function filterVideos(items) {
  let videos = [];
  items.forEach((item) => {
    if (item.type === "video") {
      videos.push(item);
    } else if (item.children) {
      videos = videos.concat(filterVideos(item.children));
    }
  });
  return videos;
}

const videoList = filterVideos(list);
function createDom(arr) {
  return arr
    .map((item, index) => {
      let icon =
        item.type == "directory"
          ? `<svg t="1702963168117" class="icon" viewBox="0 0 1024 1024" version="1.1"xmlns="http://www.w3.org/2000/svg" p-id="4251" width="20" height="20">
                <path d="M736 480c-12.5-12.5-32.8-12.5-45.3 0L523.3 647.4c-6.2 6.2-16.4 6.2-22.6 0L333.3 480c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L466.7 704c25 25 65.5 25 90.5 0L736 525.3c12.5-12.5 12.5-32.8 0-45.3z"
                  p-id="4252"></path>
                </svg>`
          : `<svg t="1702963531110" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6132" width="15" height="15" style="margin-left:2.5px;margin-right:7.5px;margin-top:3px">
                <path
                  d="M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z m0 981.333333C253.866667 981.333333 42.666667 770.133333 42.666667 512S253.866667 42.666667 512 42.666667s469.333333 211.2 469.333333 469.333333-211.2 469.333333-469.333333 469.333333z"
                  fill="#666666" p-id="6133"></path>
                <path
                  d="M672 441.6l-170.666667-113.066667c-57.6-38.4-106.666667-12.8-106.666666 57.6v256c0 70.4 46.933333 96 106.666666 57.6l170.666667-113.066666c57.6-42.666667 57.6-106.666667 0-145.066667z"
                  fill="#666666" p-id="6134"></path>
              </svg>`;
      if (item.type == "directory") {
        return `
          <li>
            <div class="vitem fold">${icon}${item.name}</div> 
            <ul>${createDom(item.children)}</ul> 
          </li>
        `;
      } else {
        return `
          <li>
            <div class="vitem play" name=${item.id}>${icon}${item.name}</div>  
          </li>
        `;
      }
    })
    .join("");
}

function countObjects(arr) {
  let count = 0;

  function traverse(arr) {
    for (let i = 0; i < arr.length; i++) {
      count++; // 遇到非数组对象，计数加一
      if (arr[i].type == "directory") {
        traverse(arr[i].children); // 递归遍历子数组
      }
    }
  }
  traverse(arr);
  return count;
}

onMounted(() => {
  /*   $(".ulbox").html(``);
  $(".ulbox").append(createDom(list)); */

  $(".ulbox").on("click", ".fold", function (e) {
    var parent = $(event.target).parent();
    var icon = $(event.target).find(".icon");
    if (icon.hasClass("iconfold")) {
      $(event.target).siblings().slideToggle(300);
      icon.removeClass("iconfold");
    } else {
      $(event.target).siblings().slideToggle(300);
      icon.addClass("iconfold");
    }
  });

  $(".ulbox").on("click", ".play", function () {
    let videoID = $(event.target).attr("name");
    let selectVideo = videoList.filter((obj) => obj.id === videoID)[0];

    $(".ulbox")
      .find(".vitem")
      .each(function () {
        $(this).removeClass("active");
      });
    $(event.target).addClass("active");
    $(".info").text(selectVideo.info);
    $(".title").text(selectVideo.name);
    $(".video").attr("src", selectVideo.url);
  });
  $(".ulbox").find(".play")[0].click();
});

const back = () => {
  history.back();
};
</script>

<style scoped>
body {
  background-color: white;
  margin: 0px;
  font-size: 16px;
}

.page {
  color: black;
}

.navi {
  height: 50px;
  margin: auto;
  border-bottom: 1px solid #e6e6e6;
  background: rgba(255, 255, 255, 0.24);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  z-index: 999;
  padding-left: 4%;
}

.back {
  height: 50px;
  line-height: 50px;
  color: #0099ff;
  font-size: 20px;
  cursor: pointer;
  font-weight: bold;
}

a {
  text-decoration: none;
}

.header {
  width: 80%;
  height: 30px;
  font-size: 20px;
  margin: 20px auto;
  font-weight: 600;
  background-color: white;
  display: flex;
  justify-content: space-between;
}

.videoBox {
  width: 80%;
  margin: 20px auto;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.left {
  width: 960px;
  min-width: 960px;
}

:deep(.directory) {
  width: 510px;
  min-width: 510px;
  background-color: rgba(244, 244, 244, 1);
  padding: 0px 20px;
  border-radius: 5px;
}

:deep(.directory-header) {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
}

:deep(.directory-content) {
  width: 100%;
  height: auto;
  padding-bottom: 10px;
}

:deep(ul) {
  list-style-type: none;
  margin: 0px;
  padding-left: 24px;
  font-size: 16px;
  overflow: hidden;
}

:deep(li) {
  line-height: 35px;
  overflow: hidden;
}

:deep(.vitem) {
  height: 35px;
  width: 100%;
  line-height: 35px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-left: 5px;
}

:deep(.vitem:hover) {
  background-color: rgba(220, 220, 220, 1);
}

:deep(.icon) {
  margin-right: 5px;
  transition: all 0.3s;
}

:deep(.iconfold) {
  transform: rotate(-90deg);
}

:deep(.active) {
  color: #0099ff;
  background-color: white;
}

:deep(.info) {
  margin-top: 20px;
  font-size: 16px;
}

:deep(.tip) {
  font-weight: 400;
  font-size: 16px;
}
/* ul li {

} */

/* .vitem {
}

.vitem:hover {
  
}
 */
/* .icon {
  margin-right: 5px;
  transition: all 0.3s;
}

.iconfold {
  transform: rotate(-90deg);
}

.active {
  color: #0099ff;
  background-color: white;
} */

/* .info {
  margin-top: 20px;
}

.tip {
  font-weight: 400;
  font-size: 16px;
} */
</style>
